import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Account } from '../interfaces/account';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};
@Injectable({ providedIn: 'root' })
export class UserService {

    private graphMeEndpoint = "https://graph.microsoft.com/v1.0/me";

    constructor(
        private authService: MsalService,
        private http: HttpClient) { }

    tdbUser: boolean;
    dealerNumber: string;
    userName: string;

    checkTdbUser() {

        let isTdbUser: boolean = false;

        let activeAccount: Account = this.authService.instance.getActiveAccount();

        for (let account of activeAccount.idTokenClaims?.roles) {
            if (account == 'frontadmin') {
                isTdbUser = true;
            }
        }


        return isTdbUser;
    }

    getCompany() {
        return this.http.get<any>(`${this.graphMeEndpoint}/companyName`, httpOptions);
    }

    storeIsTdbUser(tdbUser: boolean) {
        this.tdbUser = tdbUser;
    }

    isTdbUser() {
        return this.tdbUser;
    }

    storeDealerNumber(dealerNumber: string) {
        this.dealerNumber = dealerNumber;
    }

    getDealerNumber() {
        return this.dealerNumber;
    }

    storeUserName(userName: string) {
        this.userName = userName;
    }

    getUserName() {
        return this.userName;
    }

    logout() {
        this.authService.logout();
    }
}